export default "__VITE_ASSET__BHFsq6_j__"